import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Lock, Zap } from 'lucide-react';
import { Button } from './Button';
export function HeroSection() {
  return <section className="pt-20 pb-10 sm:pt-32 sm:pb-16 px-4 max-w-5xl mx-auto text-center" data-id="element-122">
      <motion.div initial={{
      opacity: 0,
      y: 5 // Reduced from 10 for mobile
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.2 // Even faster for mobile
    }} data-id="element-123">
        <div className="inline-block bg-white/10 backdrop-blur-sm border border-white/20 px-4 py-2 rounded-full mb-6" data-id="element-124">
          <span className="text-sm sm:text-base font-bold text-yellow-300 uppercase tracking-wider" data-id="element-125">
            ⭐ +1.200 EMPRENDEDORES YA LO APLICAN
          </span>
        </div>

        <h1 className="text-2xl sm:text-4xl md:text-5xl font-black text-white leading-tight mb-4 sm:mb-6 drop-shadow-lg uppercase max-w-4xl mx-auto" data-id="element-126">
          ¿PROBASTE VENDER POR INTERNET Y SENTÍS QUE ALGO NO ESTÁ FUNCIONANDO?
        </h1>

        <p className="text-lg sm:text-2xl text-yellow-300 font-bold mb-6 drop-shadow max-w-3xl mx-auto" data-id="element-127">
          Más de 1.200 emprendedores argentinos ya usan el Método Venta Flash IA
          para conseguir clientes online con un sistema claro y aplicable — sin
          tirar más plata a la basura.
        </p>

        {/* Mockup Image */}
        <div className="my-5 sm:my-10 mx-auto max-w-sm sm:max-w-lg md:max-w-2xl" data-id="element-128">
          <img src="https://cdn.magicpatterns.com/uploads/weZNi8v327p5FmXUx2Mo7F/metodo_flash_1280_q75.webp" srcSet="https://cdn.magicpatterns.com/uploads/weZNi8v327p5FmXUx2Mo7F/metodo_flash_1280_q75.webp 1280w, https://cdn.magicpatterns.com/uploads/weZNi8v327p5FmXUx2Mo7F/metodo_flash_1280_q75.webp 768w" sizes="(max-width: 768px) 768px, 1280px" alt="Método Venta Flash IA — Mega Pack: 5 Tomos + 3 Bonos" className="w-full h-auto object-contain drop-shadow-lg sm:drop-shadow-2xl rounded-xl" width={1280} height={720} loading="eager" fetchPriority="high" decoding="async" data-id="element-129" />
        </div>

        <p className="text-lg sm:text-xl text-white/90 font-medium mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow" data-id="element-130">
          Aprendé a organizar tu oferta, crear anuncios, usar inteligencia
          artificial y cerrar ventas por WhatsApp con un sistema claro, paso a
          paso y listo para aplicar.
        </p>

        <div className="flex flex-col sm:flex-row flex-wrap justify-center gap-3 sm:gap-8 mb-8 sm:mb-10 text-left sm:text-center max-w-4xl mx-auto" data-id="element-131">
          {['100% PDF · Acceso inmediato', 'Sin experiencia previa', 'Funciona para productos y servicios'].map((item, i) => <div key={i} className="flex items-center gap-2 text-white font-medium" data-id="element-132">
              <CheckCircle2 className="w-5 h-5 text-yellow-300 shrink-0" data-id="element-133" />
              <span data-id="element-134">{item}</span>
            </div>)}
        </div>

        <div className="max-w-md mx-auto" data-id="element-135">
          <Button href="#pricing" className="w-full text-xl py-5 mb-4" data-id="element-136">
            QUIERO MI MEGA PACK AHORA ⚡
          </Button>

          <div className="flex items-center justify-center gap-3 sm:gap-4 text-xs sm:text-sm text-white/80 font-bold flex-wrap uppercase" data-id="element-137">
            <span className="flex items-center gap-1" data-id="element-138">🔒 Pago seguro</span>
            <span data-id="element-139">·</span>
            <span className="flex items-center gap-1" data-id="element-140">⚡ Acceso inmediato</span>
            <span data-id="element-141">·</span>
            <span className="flex items-center gap-1" data-id="element-142">✅ Garantía 7 días</span>
          </div>
        </div>
      </motion.div>
    </section>;
}